import React, {useMemo} from 'react';
import {BrowserRouter} from "react-router-dom";
import Routes from '../routes/Routes';
import {ThemeProvider} from '@mui/material/styles';
import {CssBaseline} from '@mui/material';
import {useSelector} from 'react-redux';
import createAppTheme from "../../theme";

function App() {
    const isDarkMode = useSelector(state => state.theme.isDarkMode);
    const theme = useMemo(() => createAppTheme(isDarkMode), [isDarkMode]);

    return (
        <BrowserRouter>
            <ThemeProvider theme={theme}>
                <CssBaseline enableColorScheme/>
                <div className="App">
                    <Routes/>
                </div>
            </ThemeProvider>
        </BrowserRouter>
    );
}

export default App;
